const createjs = require('easeljs');
const easelbone = require('easelbone');

const RootView = easelbone.Views.Root.extend({



});

export { RootView };